// extracted by mini-css-extract-plugin
export var falconContainer = "_w1-2";
export var offerCenter = "_w1-0";
export var roktContainer = "_w1-1";